module.exports = __webpack_public_path__ + "img/BIT_white03.b0137d31.jpg";